import { SERVICE_CATEGORY_NAME } from "./config";

/**
 * Check if an article category is a service category (SERVICES or subcategory of SERVICES).
 * @param {Object} category - The category object with name and optional parent_name
 * @returns {boolean}
 */
const isServiceCategory = (category) => {
  if (!category) return false;
  const name = category.name?.toUpperCase();
  const parentName = category.parent_name?.toUpperCase();
  return name === SERVICE_CATEGORY_NAME || parentName === SERVICE_CATEGORY_NAME;
};

export default isServiceCategory;
